export default __webpack_public_path__ + "img/apple-icon-120x120.png";